import { fetchWithAuth, API_URL } from "../Componentes/fetchWithAuth"; // Asumiendo que tienes un fetchWithAuth para peticiones autenticadas

/* export const logout = async (navigate) => {
  try {
    // Opcional: Notificar al backend que la sesión ha terminado
    // Esto es crucial para invalidar el token en el servidor y mejorar la seguridad
    await fetchWithAuth("/api/logout", { method: "GET" }); // Ajusta la ruta de tu API de logout
  } catch (error) {
    console.error("Error al cerrar sesión en el backend:", error);
    // Continuar con el cierre de sesión local aunque falle la llamada al backend
  }
  // Mover la limpieza y navegación fuera del finally para asegurar que la llamada al backend tenga tiempo de completarse
  localStorage.removeItem("token");
  localStorage.removeItem("user"); // Limpia cualquier otro dato de usuario si es necesario
  navigate("/login");
};

export const isAuthenticated = () => {
  return localStorage.getItem("token") !== null;
}; */

export const logout = async (navigate, redirect = true) => {
  try {
    // Notificar al backend que la sesión ha terminado
    await fetchWithAuth(`${API_URL}/api/logout`, { method: "GET", headers: { "Content-Type": "application/json" } });
  } catch (error) {
    console.error("Error al cerrar sesión en el backend:", error);
    // Continuar con el cierre de sesión local aunque falle la llamada al backend
  } finally {
    localStorage.removeItem("token");
    localStorage.removeItem("user"); // Limpia cualquier otro dato de usuario si es necesario
    if (redirect && navigate) {
      navigate("/login");
    }
  }
};

export const isAuthenticated = () => {
  return localStorage.getItem("token") !== null;
};
